import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogContent from '@mui/material/DialogContent';
import { OpenModalContainer } from '../../../components/openModalContainer';
import { ColorPickerGroupDisplay } from './colorPickerGroupDisplay';
export const COLOR_GROUPS = [
    {
        chunkSize: 5,
        colors: [
            // hair/skin 4:
            0x78441f, 0x623a17, 0x772e1f, 0x8b181d, 0x620a16,
            // hair/skin 5:
            0x9e6731, 0xac422a, 0x864438, 0x6e3e18, 0x53381a,
            // hair/skin 6:
            0xf2b064, 0xe3b883, 0xdfa245, 0xd5a577, 0xcd832c,
            // hair/skin 7:
            0x998880, 0xd3bc9a, 0xe3c9c9, 0xcbdadb, 0xe4e1ce
        ]
        /*
        deprecated colors (too dark to see face well):
        0x270e11
        0x171111
        0x321f11
        0x051e3e
        0x251e3e
        */
    },
    {
        chunkSize: 5,
        colors: [
            // hair/skin 1:
            0xe9cba9, 0xefd1b7, 0xf7ddc2, 0xf7e2ab, 0xeec695,
            // hair/skin 2:
            0xf1c088, 0xe5bb91, 0xecbf84, 0xd19c7c, 0xcd9564,
            // hair/skin 3:
            0xbe9b7b, 0xad8b65, 0x94603b, 0xb06949, 0x7f4829
        ]
    },
    {
        chunkSize: 5,
        colors: [
            // https://coolors.co/ff595e-ffca3a-8ac926-1982c4-6a4c93
            0xff595e, 0xffca3a, 0x8ac926, 0x1982c4, 0x6a4c93,
            // https://coolors.co/264653-2a9d8f-e9c46a-f4a261-e76f51
            0x264653, 0x2a9d8f, 0xe9c46a, 0xf4a261, 0xe76f51,
            // https://coolors.co/f72585-7209b7-3a0ca3-4361ee-4cc9f0
            0xf72585, 0x7209b7, 0x3a0ca3, 0x4361ee, 0x4cc9f0,
            // https://coolors.co/cdb4db-ffc8dd-ffafcc-bde0fe-a2d2ff
            0xcdb4db, 0xffc8dd, 0xffafcc, 0xbde0fe, 0xa2d2ff
        ]
    },
    {
        colors: [
            // https://coolors.co/f8f9fa-e9ecef-dee2e6-ced4da-adb5bd-6c757d-495057-343a40-212529
            0xffffff, 0xf8f9fa, 0xe9ecef, 0xdee2e6, 0xced4da, 0xadb5bd, 0x6c757d, 0x495057, 0x343a40, 0x212529
        ]
    },
    // https://digitalsynopsis.com/design/beautiful-color-palettes-combinations-schemes/ #16
    { colors: [0x6e7f80, 0x536872, 0x708090, 0x536878, 0x36454f] },
    // https://digitalsynopsis.com/design/beautiful-color-palettes-combinations-schemes/ #4
    { colors: [0x851e3e, 0x651e3e, 0x451e3e] },
    // https://coolors.co/dad7cd-a3b18a-588157-3a5a40-344e41
    { colors: [0xdad7cd, 0xa3b18a, 0x588157, 0x3a5a40, 0x344e41] },
    { colors: [0xffc6a5, 0xff9473, 0xff6342, 0xff3118, 0xff0000, 0xd60000] },
    { colors: [0xffe7c6, 0xffce9c, 0xffb573, 0xff9c4a, 0xff8429, 0xd66321] },
    { colors: [0xffffc6, 0xffff9c, 0xffff6b, 0xffff42, 0xffff10, 0xd6c610] },
    { colors: [0xf7ffce, 0xeff8ad, 0xe7f784, 0xdef763, 0xd6ef39, 0xb5bd31] },
    { colors: [0xdef3bd, 0xc6ef8c, 0xadde63, 0x94d639, 0x7bc618, 0x639c18] },
    { colors: [0xceefbd, 0xa5de94, 0x7bc66b, 0x52b552, 0x299c39, 0x218429] },
    { colors: [0xc6e7de, 0x94d6ce, 0x63bdb5, 0x31ada5, 0x089494, 0x087b7b] },
    { colors: [0xc6eff7, 0x94d6e7, 0x63c6de, 0x31b5d6, 0x00a5c6, 0x0084a5] },
    { colors: [0xbdc6de, 0x949cce, 0x6373b5, 0xc6b5de, 0x9c7bbd, 0x7b52a5] },
    { colors: [0xdebdde, 0xce84c6, 0xb552ad, 0x9c2994, 0x8c007b, 0x730063] },
    { colors: [0xf7bdde, 0xe78cc6, 0xde5aad, 0xd63194, 0xce007b, 0xa50063] }
];
const CONTENTS_CSS = css `
  display: flex;
  flex-wrap: wrap;
  padding: 0 5px 10px 5px;
  justify-content: center;
  gap: 10px;
`;
export const ColorPickerModal = ({ title, onColorClicked, onClose, otherColorLuminosity }) => {
    return (_jsx(OpenModalContainer, { title: title, onClose: onClose, children: _jsx(DialogContent, { children: _jsx("div", { css: CONTENTS_CSS, children: COLOR_GROUPS.map((colorGroup, i) => (_jsx(ColorPickerGroupDisplay, { colorGroup: colorGroup, onColorClicked: onColorClicked, onClose: onClose, otherColorLuminosity: otherColorLuminosity }, i))) }) }) }));
};
